import React, { useContext } from "react";
import { Wrapper, Container, Content, H2, H1, P } from "./style";
import BrowseButton from "../Commons/BrowseButton";
import { ThemeContext } from "../../ThemedContext/Provider";

const headphone = "../../../assets/images/bg10.png";

const FrontPage = () => {
  const { theme } = useContext(ThemeContext);
  return (
    <Wrapper themed={theme}>
      <img src={headphone} alt='headphone' className='image' />
      <Container>
        <Content>
          <H2 className='emphasis'>OWN,</H2>
          <H1 className='hhh'>YOUR WORLD OF MUSIC</H1>
          <P>
            Where words fail, music speaks.       ~Hans Christian Anderson
          </P>
        </Content>
        <BrowseButton />
      </Container>
    </Wrapper>
  );
};

export default FrontPage;
